import React, { useEffect, useState } from "react";
import {
  BILLABLE_ACTIONS_USED_EVENT,
  billableActionsManageHref,
  formatBillableActionMeterLabel,
} from "../../../utils/billableActionsMeter";

const BillableActionsMeter = ({
  usage = 0,
  limit = 0,
  accountId,
  websiteId,
}) => {
  const [currentUsage, setCurrentUsage] = useState(usage);

  useEffect(() => {
    setCurrentUsage(usage);
  }, [usage]);

  useEffect(() => {
    const handleUsage = (event) => {
      const increment = Number(event.detail && event.detail.count) || 1;
      setCurrentUsage((value) => value + increment);
    };

    document.addEventListener(BILLABLE_ACTIONS_USED_EVENT, handleUsage);
    return () =>
      document.removeEventListener(BILLABLE_ACTIONS_USED_EVENT, handleUsage);
  }, []);

  const numericLimit = Number(limit);
  if (!numericLimit || numericLimit <= 0) return null;

  const manageHref = billableActionsManageHref(accountId, websiteId);

  return (
    <div
      className="flex items-center justify-between gap-3 px-4 py-2.5 rounded-b-xl border-0 border-t border-solid border-[rgba(209,224,255,0.6)] dark:border-slate-700 bg-[linear-gradient(135deg,rgb(214,224,255)_0%,rgb(209,224,255)_50%,rgb(245,248,253)_100%)] dark:bg-[linear-gradient(135deg,rgba(0,63,255,0.28)_0%,rgba(30,58,138,0.35)_50%,rgba(15,23,42,0.6)_100%)]"
      data-testid="billable-actions-meter"
    >
      <span className="min-w-0 truncate text-lg text-gray-900 dark:text-slate-200">
        {formatBillableActionMeterLabel(currentUsage, numericLimit)}
      </span>
      {manageHref && (
        <a
          href={manageHref}
          target="_blank"
          rel="noopener noreferrer"
          className="text-lg text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300 no-underline shrink-0"
        >
          Manage
        </a>
      )}
    </div>
  );
};

export default BillableActionsMeter;
